import styled from 'styled-components';

export default styled.div`
  align-items: center;
  display: flex;
  float: right;
  margin-top: 15px;
`;
